import StaffCustomers from './StaffCustomers'

export * from './StaffCustomers'

export default StaffCustomers
